import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function updateUserName(payload) {
  try {
    const url = paths.updateUserName(); 
    const response = await axiosInstance.post(url, payload); 
    return response.data; 
  } catch (error) {
    return Promise.reject(error);
  }
}

const useUpdateUserName = () => {
  return useMutation({
    mutationFn: updateUserName, 
  });
};

export { useUpdateUserName };